import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ProductVariantAttributeRequest,
  ProductVariantAttributeResponse,
  ProductVariantAttributeValueRequest,
  ProductVariantAttributeValueResponse
} from '../models/producto-variant-attribute.model';

@Injectable({
  providedIn: 'root'
})
export class ProductoVariantAttributeApiService {
  private readonly apiUrl = `${environment.apiUrl}api/products`;

  constructor(private http: HttpClient) { }

  getProductVariantAttributes(productId: number): Observable<ProductVariantAttributeResponse[]> {
    return this.http.get<ProductVariantAttributeResponse[]>(`${this.apiUrl}/${productId}/variant-attributes`);
  }

  createProductVariantAttribute(productId: number, req: ProductVariantAttributeRequest, businessId: number): Observable<ProductVariantAttributeResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<ProductVariantAttributeResponse>(`${this.apiUrl}/${productId}/variant-attributes`, req, { params });
  }

  deleteProductVariantAttribute(productId: number, attributeId: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/${productId}/variant-attributes/${attributeId}`, { params });
  }

  addProductVariantAttributeValue(productId: number, attributeId: number, req: ProductVariantAttributeValueRequest, businessId: number): Observable<ProductVariantAttributeValueResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<ProductVariantAttributeValueResponse>(`${this.apiUrl}/${productId}/variant-attributes/${attributeId}/values`, req, { params });
  }

  deleteProductVariantAttributeValue(productId: number, attributeId: number, valueId: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/${productId}/variant-attributes/${attributeId}/values/${valueId}`, { params });
  }
}
